import React, { useState, useRef, useCallback, useEffect } from "react";
import { Checkmark } from "../icons/deprecated/Checkmark";
import cx from "classnames";
import "./Checkbox.scss";
import { useValidation } from "../../hooks/useValidation";
import { useForm } from "../../hooks/useForm";
import { InputErrorList } from "../input/InputErrorList";
export function Checkbox({ checked = false, onChange, alternative, forceValidation = false, validators = [], "data-test-id-partial": dataTestIdPartial, }) {
    const [isAnimating, setIsAnimating] = useState(false);
    const ref = useRef(null);
    const containerRef = useRef(null);
    const timeout = useRef(null);
    const checkboxName = useRef("checkbox_" + Math.random().toString(36).substr(2, 9));
    const classes = cx("lysa-ripple-box", { "is-animating": isAnimating });
    const [validity, errorMessages, validityClasses, resetValidation] = useValidation(checked ? alternative : undefined, validators, forceValidation);
    const dataTestId = dataTestIdPartial !== undefined
        ? dataTestIdPartial + "-" + alternative.value
        : undefined;
    useForm(checkboxName.current, validity, checked ? alternative.value : undefined, resetValidation, containerRef, errorMessages, alternative.text);
    useEffect(() => {
        return () => {
            if (timeout.current) {
                clearTimeout(timeout.current);
            }
        };
    }, []);
    useEffect(() => {
        var _a, _b;
        const savedRef = ref;
        const notAnimating = () => setIsAnimating(false);
        if (isAnimating) {
            (_a = savedRef.current) === null || _a === void 0 ? void 0 : _a.addEventListener("animationend", notAnimating);
        }
        else {
            (_b = savedRef.current) === null || _b === void 0 ? void 0 : _b.removeEventListener("animationend", notAnimating);
        }
        return () => {
            var _a;
            (_a = savedRef.current) === null || _a === void 0 ? void 0 : _a.removeEventListener("animationend", notAnimating);
        };
    }, [isAnimating, ref]);
    const onClick = useCallback((event) => {
        var _a;
        event.stopPropagation();
        setIsAnimating(false);
        if ((_a = ref.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect) {
            const offsets = ref.current.getBoundingClientRect();
            ref.current.style.setProperty("--x", (event.clientX - offsets.left).toString());
            ref.current.style.setProperty("--y", (event.clientY - offsets.top).toString());
        }
        timeout.current = setTimeout(() => {
            var _a;
            void ((_a = ref.current) === null || _a === void 0 ? void 0 : _a.offsetWidth);
            setIsAnimating(true);
        }, 0);
    }, [ref]);
    return (React.createElement("div", { ref: containerRef, className: "lysa-ui-input-group" },
        React.createElement("div", { className: cx("lysa-ui-checkbox", validityClasses) },
            React.createElement("input", { id: checkboxName.current, name: checkboxName.current, type: "checkbox", disabled: alternative.disabled, onChange: () => onChange === null || onChange === void 0 ? void 0 : onChange(alternative), onClick: (event) => event.stopPropagation(), checked: checked }),
            React.createElement("label", { htmlFor: checkboxName.current, className: classes, ref: ref, onClick: onClick, "data-test-id": dataTestId },
                React.createElement("span", { className: "checkmark-box" },
                    React.createElement(Checkmark, { size: 14, color: "#FFF" })),
                React.createElement("span", { className: "text" }, alternative.text),
                React.createElement("span", { className: "lysa-ripple" })),
            React.createElement(InputErrorList, { errorMessages: errorMessages }))));
}
